var single_bonbon_flavors = [];
var single_bonbon_allergens = [];
var is_flavor_checked = {};
var is_allergen_checked = {};

$(document).ready(function(){
    $('div.shopingcart_div a').on('click', function(e){
      e.preventDefault();
      $('cart-drawer.drawer').addClass('animate active');
    });
  
  // Make non customizable product first option selected
  $(".product_composition li a").first().addClass('active');
  
  $(".tablinks").click(function(){
    $(".tablinks").removeClass("active");
    $(this).addClass("active");

    var tabName = $(this).attr("data-tab");
    $(".tabcontent").hide();
    $(".nested-tabcontent").hide();
    $("#" + tabName).show();

    // Preserve the active nested tab if one exists; otherwise fall back to the first
    var $activeNested = $("#" + tabName + " .nested-tablinks.active").first();
    var activeNestedTab = $activeNested.data("tab");
    if (activeNestedTab) {
      $("#" + activeNestedTab).show();
    } else {
      $("#" + tabName + " .nested-tabcontent:first").show();
    }

    if (tabName !== "cadeu") {
      $("#cadeu").hide();
    }
  });

  $(".nested-tablinks").click(function(){
    $(this).closest(".nested-tab").find(".nested-tablinks").removeClass("active");
    $(this).addClass("active");

    var nestedTabName = $(this).attr("data-tab");
    $(".nested-tabcontent").hide();
    $("#" + nestedTabName).show();
  });


  $("button.next_click").click(function(event) {
        event.preventDefault();

        if($(this).hasClass('selected-bonbons-next'))
        {
          $('#Nestedgiftwrap .choose_gift_wrap .giftwrap_checkbox .custom-checkbox .gift-wrapping-checkbox').trigger('click');
          
          let selectedBonbonList = [];
          $(this).parent().find('.product_selected_flavour ul li a').each(function() {
              let bonbonImage = $(this).find('img').attr('src'); // Get the image URL
              let bonbonName = $(this).find('p.bonbon-name').text(); // Get the bonbon name
              selectedBonbonList.push({
                  name: bonbonName,
                  image: bonbonImage
              });
          });
          
          if (selectedBonbonList.length > 0) 
          {
              var finalSelectedBonbons = document.querySelectorAll('div .product-form .form #selected_bonbon_name');
              finalSelectedBonbons.forEach(function(input) {
                  var formattedList = selectedBonbonList.map(item => `${item.name} (${item.image})`).join(', ');
                  input.value = formattedList;
              });
          }
        }
  
        var $currentTab = $(".nested-tablinks.active");
        var $nextTab = $currentTab.next(".nested-tablinks[data-tab]");        
        if ($nextTab.length > 0) {
            $currentTab.removeClass("active");
            $nextTab.addClass("active");
            $(".nested-tabcontent").hide();
            $("#" + $nextTab.data("tab")).show();
        }
   });
    
   $("button.previous_click:first-of-type").click(function(event) {
        event.preventDefault();
        var $currentTab = $(".nested-tablinks.active");
        var $prevTab = $currentTab.prev(".nested-tablinks[data-tab]");        
        if ($prevTab.length > 0) {
            $currentTab.removeClass("active");
            $prevTab.addClass("active");
            $(".nested-tabcontent").hide();
            $("#" + $prevTab.data("tab")).show();
        }
   });

  $("button[data-tab='omschrijving']").click(function(){
    $(".tabcontent").hide();
    $(".nested-tabcontent").hide();
    $("#omschrijving").show();
    $("#cadeu").hide();

    $(".tablinks").removeClass("active");
    $(this).addClass("active");
  });

  $('#addCardCheckbox').change(function(){
        if(this.checked){
            $('#messageBox').show();
            var message_price = $(this).next().next().data('variant-id');
            var variant_price = $(this).val();
            var variant_compare_at_price = $(this).data('compare-at-price');
            $('div.product div product-info div div.price div.price__container div.price__regular span.price-item').text(variant_price);
            $('div.product div product-info div div.price div.price__container div.price__sale span.price-item').text(variant_price);
            $('div.product div product-info div div.price div.price__container div.price__sale span s').text(variant_compare_at_price);
            $(this).closest('.add_message_section').parent().find('.message_button div .product-form form').find('input[name="id"]').val(message_price);
            $('.message_button div .product-form .form .product-form__buttons > button').addClass('disabled-button');
            $('#noCardCheckbox').prop('checked', false);
        } else {
            $('#messageBox').hide();
        }
    });

  $('#noCardCheckbox').change(function(){
      if(this.checked){
          $('#messageBox').hide();
          // $(this).closest('.add_message_section').find('#messageBox #message').prop('required', false);
          // $('#messageBox #message').prop('required', false);
          var message_price = $(this).next().next().data('variant-id');
          var variant_price = $(this).val();
          var variant_compare_at_price = $(this).data('compare-at-price');
          $('div.product div product-info div div.price div.price__container div.price__regular span.price-item').text(variant_price);
          $('div.product div product-info div div.price div.price__container div.price__sale span.price-item').text(variant_price);
          $('div.product div product-info div div.price div.price__container div.price__sale span s').text(variant_compare_at_price);
          //console.log(message_price);
          $(this).closest('.add_message_section').parent().find('.message_button div .product-form form').find('input[name="id"]').val(message_price);
          $('.message_button div .product-form .form .product-form__buttons > button').removeClass('disabled-button');
          $('#addCardCheckbox').prop('checked', false);
          $(this).closest('.add_message_section').next('.message_button').find('div .product-form .form #user_custom_message').val("Ik wil geen kaart toevoegen");
      }
  });
  $('#noCardCheckbox').prop('checked', true).trigger('change');

  $('.product_composition li a').on('click' , function(e){
    e.preventDefault();
    $('.product_composition li a').removeClass('active');
    $(this).addClass('active');
  });

  $(".allergenen_filter a").click(function(){
    event.preventDefault();
        $(this).toggleClass("active");
        $(this).next("ul").toggle();
  });

  $('#cadeu #Nestedmessage .product_your_message .add_message_section .custom-checkbox #noCardCheckbox').on('click', function(){
    var siblingCheckbox = $(this).closest('.custom-checkbox').parent();
    var textareaInsideSibling = siblingCheckbox.find('#messageBox #message');
    var characterCount = siblingCheckbox.find('#messageBox #characterCount');
    textareaInsideSibling.val('');
    characterCount.text('Max. 250 tekens');
    $(this).closest('.add_message_section').next('.message_button').find('div .product-form .form #user_custom_message').val("Ik wil geen kaart toevoegen");
    $(this).closest('.add_message_section').next('.message_button').find('div .product-form .form .product-form__buttons > button').addClass('disabled-button');
  });


  var gift_wrapper_name = $('.choose_gift_wrap .choose_gifts ul li a.active span').text();
  var gift_wrapper_image = $('.choose_gift_wrap .choose_gifts ul li a.active img').attr('src');
  if(gift_wrapper_name)
  {
    var selected_gift_wrapper = document.querySelectorAll('div .product-form .form #selected_giftwrapping_name');
    selected_gift_wrapper.forEach(function(input) {
      input.value = gift_wrapper_name + '+' + gift_wrapper_image;
    });
  }
  else
  {
    /*
     * Auto-select the first in-stock sleeve on page load so the cart
     * line property #selected_giftwrapping_name is NEVER empty on
     * Add-to-Cart. Empty value caused ~47% of build-your-box orders to
     * silently ship with no sleeve deducted from inventory.
     * The customer can still change their mind by clicking another tile
     * or the "geen mouw geselecteerd" radio.
     */
    var firstAvailableSleeve = $('.choose_gift_wrap .choose_gifts ul li').not('.out_of_stock').first().find('a.gift-box');
    if (firstAvailableSleeve.length) {
      firstAvailableSleeve.addClass('active');
      var preName = firstAvailableSleeve.find('span').text();
      var preImage = firstAvailableSleeve.find('img').attr('src');
      if (preName) {
        document.querySelectorAll('div .product-form .form #selected_giftwrapping_name').forEach(function(input) {
          input.value = preName + '+' + (preImage || '');
        });
      }
    }
  }

  $('.choose_gift_wrap .choose_gifts ul li a.gift-box').on('click', function(e){
    e.preventDefault();
    $('.choose_gift_wrap .choose_gifts ul li a.gift-box').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.choose_gifts').siblings('.giftwrap_checkbox').find('.custom-checkbox span.gift-wrapping-checkbox').removeClass('has-after');
    $(this).closest('.choose_gifts').siblings('.message_button').find('.next_click.selected-gift-wrapper-next').removeClass('left_to_filled');
    $('.product_selected_flavour ul li a').closest('.selection_choclate_data').closest('.nested-tabcontent').prev('.nested-tab').find('button[data-tab="Nestedmessage"]').removeClass('left_to_filled');
    var imgsrc = $('.choose_gift_wrap .choose_gifts ul li a.active img').data('big-image');
    var gift_wrapper_name = $('.choose_gift_wrap .choose_gifts ul li a.active span').text();
    var gift_wrapper_image = $('.choose_gift_wrap .choose_gifts ul li a.active img').attr('src');
    var selected_gift_wrapper = document.querySelectorAll('div .product-form .form #selected_giftwrapping_name');
    selected_gift_wrapper.forEach(function(input) {
      input.value = gift_wrapper_name + '+' + gift_wrapper_image;
    });
    var videoElement = $('.giftwrap_single_image video');
    var scrollOffset = $(window).width() >= 768 && $(window).width() <= 991 ? 1400 : 1500;

    // var prevDivOffset = videoElement.closest('.selected-gift-wrapper-next').prev('.giftwrap_single_image').offset().top;
    // var prevDivOffset = $(this).parent().parent().parent().parent().parent().find('div.gift_title').offset().top;
    // var prevDivOffset = 0;
    // if($(window).width() <= 991)
    // {
    //   console.log("inside if");
    //   prevDivOffset = $(this).parent().parent().parent().parent().parent().find('div.gift_title').offset().top - 200;
    // }
    // else
    // {
    //   console.log("inside else");
    //   prevDivOffset = $(this).parent().parent().parent().parent().parent().find('div.gift_title').offset().top;
    // }
    // console.log(prevDivOffset);

    // var loadingIndicator = $('<div class="loading-indicator">Loading...</div>');
    // videoElement.after(loadingIndicator);

    // videoElement.find('source').attr('src', imgsrc);
    // $('html, body').animate({ scrollTop: $('.selected-gift-wrapper-next').offset().top - scrollOffset }, 'fast');
    // videoElement[0].load();

    $('.giftwrap_single_image .loader').show();

    videoElement.find('source').attr('src', imgsrc);
    // $('html, body').animate({ scrollTop: $('.selected-gift-wrapper-next').offset().top - scrollOffset }, 'slow');
    $('html, body').animate({ scrollTop: $(this).parent().parent().parent().parent().parent().find('div.gift_title').offset().top }, 'fast');
    
    videoElement[0].addEventListener('loadeddata', function() {
      // Video has finished loading, hide the loader
      $('.giftwrap_single_image .loader').hide();
    });
    
    videoElement[0].load();
    
    // videoElement.off('loadeddata');  // Remove previous event handlers
    // videoElement.on('loadeddata', function() {
    //   // loadingIndicator.remove();
    //     $('html, body').animate({ scrollTop: $('.selected-gift-wrapper-next').offset().top - scrollOffset }, 'fast');
    // });
    
  });

   if ($(window).width() >= 367 && $(window).width() <= 767) 
  {
    $('.choose_gift_wrap .message_button .selected-gift-wrapper-next').on('click', function(){
      $('html, body').animate({
        scrollTop: 1350
      }, 'slow');

      var no_gift_wrapper = $(this).closest('div.message_button').parent().find('div.giftwrap_checkbox label span.gift-wrapping-checkbox');
      $('#addCardCheckbox').prop('checked', true).trigger('change');
    });

    $('#Nestedselectchoko .products_select_choko_data .composition_button .premade_next').on('click', function(){
       $('html, body').animate({
        scrollTop: 1350
      }, 'slow');

      $('#addCardCheckbox').prop('checked', true).trigger('change');
    });

    $('#Nestedselectchoko .products_select_choko_data .product_composition li a.premade_box_options').on('click', function(){
      // $('html, body').animate({
      //   scrollTop: 1300
      // }, 'slow');
      $('html, body').animate({
        scrollTop: $('.premade_next').offset().top - 500
      }, 'slow');
    });
    

    $('.product-tabcontent .nested-tabcontent .selected-bonbons-next').on('click', function(){
      $('html, body').animate({
        scrollTop: 1400
      }, 'slow');
    });
  }
  else if ($(window).width() >= 768 && $(window).width() <= 991) 
  {
    $('.choose_gift_wrap .message_button .selected-gift-wrapper-next').on('click', function(){
      $('html, body').animate({
        scrollTop: 1100
      }, 'slow');
      var no_gift_wrapper = $(this).closest('div.message_button').parent().find('div.giftwrap_checkbox label span.gift-wrapping-checkbox');
      $('#addCardCheckbox').prop('checked', true).trigger('change');
    });

    $('#Nestedselectchoko .products_select_choko_data .composition_button .premade_next').on('click', function(){
       $('html, body').animate({
        scrollTop: 1000
      }, 'slow');

      $('#addCardCheckbox').prop('checked', true).trigger('change');
    });

    $('#Nestedselectchoko .products_select_choko_data .product_composition li a.premade_box_options').on('click', function(){
      // $('html, body').animate({
      //   scrollTop: 1100
      // }, 'slow');
      $('html, body').animate({
        scrollTop: $('.premade_next').offset().top - 500
      }, 'slow');
    });

    $('.product-tabcontent .nested-tabcontent .selected-bonbons-next').on('click', function(){
      $('html, body').animate({
        scrollTop: 1200
      }, 'slow');
    });
  }
  else
   {
     $('.product-tabcontent .nested-tabcontent .selected-bonbons-next').on('click', function(){
      $('html, body').animate({
        scrollTop: 1000
      }, 'slow');
    });
     
     $('.choose_gift_wrap .message_button .selected-gift-wrapper-next').on('click', function(){
      $('html, body').animate({
        scrollTop: 860
      }, 'slow');
       
      var no_gift_wrapper = $(this).closest('div.message_button').parent().find('div.giftwrap_checkbox label span.gift-wrapping-checkbox');
      $('#addCardCheckbox').prop('checked', true).trigger('change');
    });

     $('#Nestedselectchoko .products_select_choko_data .composition_button .premade_next').on('click', function(){
       $('html, body').animate({
        scrollTop: 890
      }, 'slow');

      $('#addCardCheckbox').prop('checked', true).trigger('change');
    });

     $('#Nestedselectchoko .products_select_choko_data .product_composition li a.premade_box_options').on('click', function(){
      // $('html, body').animate({
      //   scrollTop: 900
      // }, 'slow');
       $('html, body').animate({
        scrollTop: $('.premade_next').offset().top - 500
      }, 'slow');
    });
     
   }
  

   $('.giftwrap_checkbox .custom-checkbox p').on('click', function(){
      $(this).prev('.gift-wrapping-checkbox').trigger('click');
      $('html, body').animate({
         scrollTop: $('.selected-gift-wrapper-next').offset().top - 1500
        }, 'fast');
   });

  
  $('.giftwrap_checkbox .custom-checkbox .gift-wrapping-checkbox').on('click', function(){
    var chooseGifts = $('.choose_gift_wrap .choose_gifts');
    chooseGifts.find('ul li a').removeClass('active');
    $(this).addClass('has-after');
    var videoElement = chooseGifts.parent().siblings('.giftwrap_single_image').find('video');
    videoElement.find('source').attr('src', 'https://cdn.shopify.com/videos/c/o/v/d1b5f3bfb732497ea06bd1e359ad6dca.mp4');
    videoElement[0].load();
    $(this).closest('.giftwrap_checkbox').siblings('.message_button').find('.next_click.selected-gift-wrapper-next').addClass('left_to_filled');
    $('.product_selected_flavour ul li a').closest('.selection_choclate_data').closest('.nested-tabcontent').prev('.nested-tab').find('button[data-tab="Nestedmessage"]').addClass('left_to_filled');
    var gift_wrapper_name = $('.choose_gift_wrap .choose_gifts ul li a.active span').text();
    var gift_wrapper_image = $('.choose_gift_wrap .choose_gifts ul li a.active img').attr('src');
    var selected_gift_wrapper = document.querySelectorAll('div .product-form .form #selected_giftwrapping_name');
    selected_gift_wrapper.forEach(function(input) {
      input.value = gift_wrapper_name + '+' + gift_wrapper_image;
    });

    
    $(this).closest('.giftwrap_checkbox').siblings('.message_button').find('.next_click.selected-gift-wrapper-next').removeClass('left_to_filled');
    $('.product_selected_flavour ul li a').closest('.selection_choclate_data').closest('.nested-tabcontent').prev('.nested-tab').find('button[data-tab="Nestedmessage"]').removeClass('left_to_filled');
    var selected_gift_wrapper = document.querySelectorAll('div .product-form .form #selected_giftwrapping_name');
    selected_gift_wrapper.forEach(function(input) {
      input.value = 'Geen mouw geselecteerd';
    });
  });
    

  /*========================================================================================================================================================
  * This is the process for putting selected (clicked) single bonbon into selected side of bonbon UI.
  * When user clicks one of the image (.product_filter_images ul li a) from avaiable list of bonbon it will get appended to selected flavor list 
  * (.product_selected_flavour ul li )
  ==========================================================================================================================================================*/
  $( document ).on( 'click', '.product_filter_images ul li a', ( event ) => {
    
    event.preventDefault();
    
    let left_to_filled = false;

    const bonbons = $('.product_selected_flavour ul li a');
    bonbons.each((key, selected_bonbon) => 
    {
      if ($(selected_bonbon).is(':empty')) 
      {
          $(selected_bonbon).html($(event.target).closest('li').find('a').html());
          $(selected_bonbon).parent('li').addClass('show-minus-sign');
          // $('.next_click').addClass('left_to_filled');
          // console.log(bonbons.closest('.selection_choclate_data').closest('.nested-tabcontent').prev('.nested-tab').find('button[data-tab="Nestedgiftwrap"]').addClass('left_to_filled'));
          left_to_filled = true;
          if (key === bonbons.length - 1) 
          {
            bonbons.closest('.selection_choclate_data').closest('.nested-tabcontent').prev('.nested-tab').find('button[data-tab="Nestedgiftwrap"]').removeClass('left_to_filled');
            $('.next_click.selected-bonbons-next').removeClass('left_to_filled');

            
            if ($(window).width() >= 367 && $(window).width() <= 767) 
            {
              $('html, body').animate({
                scrollTop: $('.selected-bonbons-next').offset().top - 500
              }, 'slow');
            } 
            else if ($(window).width() >= 768 && $(window).width() <= 991) 
            {
              $('html, body').animate({
                scrollTop: $('.selected-bonbons-next').offset().top - 550
              }, 'slow');
            } 
            else 
            {
              $('html, body').animate({
                scrollTop: $('.selected-bonbons-next').offset().top - 580
              }, 'slow');
            }
            
            
          }
          return false;
      }
    });
      
  } );

  /*========================================================================================================================================================
  * This is the process for removing selected (clicked) single bonbon from selected side of bonbon UI.
  * When user clicks one of the image (.product_selected_flavour ul li a) from selected list of bonbon it will get removed from selected flavor list 
  * and all bonbons next to it will be moved left by one to empty the last space in the selected list
  ==========================================================================================================================================================*/
$(document).on('click', '.product_selected_flavour ul li a', (event) => {
    event.preventDefault();

    
    let removed_bonbon = $(event.target).closest('li').find('a')[0];
    if ($(removed_bonbon).is(':not(:empty)')) {
      $('.next_click.selected-bonbons-next').addClass('left_to_filled');
      $('.product_selected_flavour ul li a').closest('.selection_choclate_data').closest('.nested-tabcontent').prev('.nested-tab').find('button[data-tab="Nestedgiftwrap"], button[data-tab="Nestedmessage"]').addClass('left_to_filled');
        let move_left = false;
        $(event.target).closest('ul').find('a').each((key, bonbon) => {

            if (bonbon == removed_bonbon) {
                move_left = true;
                $(removed_bonbon).empty();
                if ($(removed_bonbon).find('img').length > 0) {
                    $(removed_bonbon).parent('li').removeClass('show-minus-sign');
                }
            }

            if (move_left) {
                let next_bonbon = $(bonbon).closest('li').next().find('a')[0];
                $(bonbon).html($(next_bonbon).html());
                $(next_bonbon).empty();
                if ($(bonbon).find('img').length > 0) {
                    $(bonbon).parent('li').addClass('show-minus-sign');
                } else {
                    $(bonbon).parent('li').removeClass('show-minus-sign');
                }
            }
        });
    }
});
  
  /*========================================================================================================================================================
  * This is the process for filtering the list of available bonbons based on the flavor and allergens specified above it.
  * Normally list contains all the bonbons and hence all flavors and allergens are selected. Once user make some changes to the selection, it will update
  * the list of available bonbons correspondingly
  ==========================================================================================================================================================*/
  // Filter with Flavor
  $( document ).on( 'click', '.single_bonbon_flavor', ( event ) => {

    event.preventDefault();
    if( is_flavor_checked[ $( event.target ).html() ] ) {
      
      $( event.target ).removeClass( 'single_bonbon_flavor_checked' );
      $( event.target ).addClass( 'single_bonbon_flavor_unchecked' );
      is_flavor_checked[ $( event.target ).html() ] = false;
    } else {

      $( event.target ).removeClass( 'single_bonbon_flavor_unchecked' );
      $( event.target ).addClass( 'single_bonbon_flavor_checked' );
      is_flavor_checked[ $( event.target ).html() ] = true;
    }

    update_available_product_list();
  } );

  // Filter with Allergen
  $( document ).on( 'click', '.single_bonbon_allergen', ( event ) => {

    if( $( event.target ).closest( '.single_bonbon_allergen' ).find( 'input[type=checkbox]' ).is( ':checked' ) )
      is_allergen_checked[ $( event.target ).closest( '.single_bonbon_allergen .custom-checkbox' ).text() ] = true;
    else
      is_allergen_checked[ $( event.target ).closest( '.single_bonbon_allergen .custom-checkbox' ).text() ] = false;
    
    update_available_product_list();
  } );

  
});

function update_available_product_list() {
  $( '.product_filter_images ul li' ).each( ( key, selected_bonbon ) => {
    
    if( ! is_flavor_checked[ single_bonbon_flavors[ key ] ] )
    {
      if( ! $(selected_bonbon).hasClass('out-of-stock'))
      {
         $(selected_bonbon).addClass('hidden-product');
      }
    }
     
    else {

          let single_bonbon_allergens_string = JSON.stringify(single_bonbon_allergens?.[key] ?? '');
          let unwanted_allergen_found = false;
          $.each( is_allergen_checked, ( allergen, checked ) => {
            if( ( ! checked ) && ( single_bonbon_allergens_string.indexOf( allergen ) != -1 ) ) {
              unwanted_allergen_found = true;
              $(selected_bonbon).addClass('hidden-product');
              return false;
            }
          } );
          if( ! unwanted_allergen_found )
             $(selected_bonbon).removeClass('hidden-product');
        }
  } );
}


// Select Dropdown QTY Javascript Code
// document.addEventListener("DOMContentLoaded", function() {
//     var selectDropdown = document.getElementById("quantity-select");
//     var hiddenInput = document.querySelector(".quantity__input");
//     selectDropdown.addEventListener("change", function() {
//         hiddenInput.value = this.value;
//         hiddenInput.dispatchEvent(new Event('change'));
//     });
// });

$(document).ready(function(){
  $('#quantity-select').on('change', function() {
    $('.quantity__input').val($(this).val()).change();
  });
});



$(document).on('click', '.cart-item__name', function() {
    $(this).next('.details-content').toggle();
});

$(document).ready(function() {
    if (document.querySelectorAll('div.product_filter_images ul li').length > 15) 
    {
      $('div.product_filter_images').addClass('scrollable');
    }
    else
    {
      $('div.product_filter_images').removeClass('scrollable');
    }

    // $('.products_filter_data .product_filter_images li').on('click', function() {
    //   $(this).addClass('gray-bg');
    //   setTimeout(() => {
    //     $(this).removeClass('gray-bg');
    //   }, 1000);
    // });
  
});


/* $(document).ready(function() {
  function applyResponsiveFilter() {
    if ($(window).width() <= 768) {
      $('.products_filter_data .product_filter_images li').on('click', function() {
        $(this).addClass('gray-bg');
        setTimeout(() => {
          $(this).removeClass('gray-bg');
        }, 1000);
      });
    } else {
      $('.products_filter_data .product_filter_images li').off('click');
    }
  }

  applyResponsiveFilter();
  
  $(window).resize(function() {
    applyResponsiveFilter();
  });
}); */


